import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Container, Row, Col, Button } from 'react-bootstrap';
import axios from 'axios';

const RequestAccessForm = () => {
    const validationSchema = Yup.object({
        firstName: Yup.string().required('First Name is required'),
        lastName: Yup.string().required('Last Name is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        agencyName: Yup.string().required('Agency Name is required'),
        streetAddress: Yup.string().required('Street Address is required'),
        city: Yup.string().required('City is required'),
        state: Yup.string().required('State is required'),
        zipCode: Yup.string().required('Zip Code is required'),
        phoneNumber: Yup.string()
            .matches(/^[0-9]+$/, 'Phone number must be only digits')
            .required('Phone Number is required'),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        // Prepare the JSON data to send
        const requestData = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            agencyName: values.agencyName,
            requestAddress: {
                streetAddress: values.streetAddress,
                city: values.city,
                state: values.state,
                zipCode: values.zipCode,
            },
            phoneNumber: values.phoneNumber,
        };

        // Make the API request with axios
        axios.post(`${process.env.REACT_APP_API_URL}/RequestAccess`, requestData)
            .then(response => {
                // Handle successful response
                alert('Your request has been submitted successfully!');
                resetForm();
            })
            .catch(error => {
                let errorMessage = 'An error occurred.';

                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.error('Response error:', error.response.data);
                    errorMessage = error.response.data.message || 'An error occurred with the server response.';
                } else if (error.request) {
                    // The request was made but no response was received
                    console.error('Request error:', error.request);
                    errorMessage = 'No response received from the server. Please try again later.';
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.error('General error:', error.message);
                    errorMessage = error.message || 'An error occurred during the request setup.';
                }

                alert(`There was an error submitting your request: ${errorMessage}`);
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    return (
        <Container>
            <Row className="justify-content-center">
                <Col md={8}>
                    <div style={{ backgroundColor: '#f8f9fa', padding: '30px', borderRadius: '10px', boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)' }}>
                        <h2 style={{ marginBottom: '20px' }}>Request Access</h2>
                        <p>If your agency is currently receiving payments from United Way of greater Los Angeles, you can request access to view the details of the payments by filling in this form. A United way representative will be in touch with you shortly.</p>
                        <Formik
                            initialValues={{
                                firstName: '',
                                lastName: '',
                                email: '',
                                agencyName: '',
                                streetAddress: '',
                                city: '',
                                state: '',
                                zipCode: '',
                                phoneNumber: '',
                            }}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ isSubmitting }) => (
                                <Form>
                                    <Row>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="firstName">First Name</label>
                                                <Field type="text" name="firstName" className="form-control" />
                                                <ErrorMessage name="firstName" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="lastName">Last Name</label>
                                                <Field type="text" name="lastName" className="form-control" />
                                                <ErrorMessage name="lastName" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="email">Email</label>
                                                <Field type="email" name="email" className="form-control" />
                                                <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="agencyName">Agency Name</label>
                                                <Field type="text" name="agencyName" className="form-control" />
                                                <ErrorMessage name="agencyName" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="streetAddress">Street Address</label>
                                                <Field type="text" name="streetAddress" className="form-control" />
                                                <ErrorMessage name="streetAddress" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="city">City</label>
                                                <Field type="text" name="city" className="form-control" />
                                                <ErrorMessage name="city" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="state">State</label>
                                                <Field type="text" name="state" className="form-control" />
                                                <ErrorMessage name="state" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="zipCode">Zip Code</label>
                                                <Field type="text" name="zipCode" className="form-control" />
                                                <ErrorMessage name="zipCode" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label htmlFor="phoneNumber">Phone Number</label>
                                                <Field type="text" name="phoneNumber" className="form-control" />
                                                <ErrorMessage name="phoneNumber" component="div" style={{ color: 'red' }} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Button variant="primary" type="submit" disabled={isSubmitting} style={{ marginTop: '10px' }}>
                                        Submit
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default RequestAccessForm;